import { ɵɵdefineInjectable, ɵɵinject, Injectable, Inject, Optional, EventEmitter, Component, Injector, Input, Output, ViewChild, Pipe, NgModule } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { saveAs } from 'file-saver';
import { NotificationsService } from '@mt-ng2/notifications-module';
import { ClaimsService, ClaimValues } from '@mt-ng2/auth-module';
import { SearchParams } from '@mt-ng2/common-classes';
import { SortDirection, EntityListConfig, EntityListColumn, EntityListModule } from '@mt-ng2/entity-list-module';
import { ComponentErrorHandler, ComponentErrorHandlerModule } from '@mt-ng2/component-error-handler';
import { EntityComponentsDocumentsModuleConfigToken } from '@mt-ng2/entity-components-documents-config';
import { debounceTime } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { getFontAwesomeFileImage } from '@mt-ng2/format-functions';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MtDocumentControlModule } from '@mt-ng2/document-control';
import { DynamicFormModule } from '@mt-ng2/dynamic-form';
import { MtAlertsModule } from '@mt-ng2/alerts-module';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@mt-ng2/component-error-handler';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@mt-ng2/alerts-module';
import * as ɵngcc4 from '@mt-ng2/document-control';
import * as ɵngcc5 from '@angular/forms';
import * as ɵngcc6 from '@mt-ng2/entity-list-module';
import * as ɵngcc7 from '@angular/router';

function CommonDocumentsComponent_ng_container_1_div_2_div_5_div_4_span_10_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 16);
    ɵngcc0.ɵɵlistener("mtConfirm", function CommonDocumentsComponent_ng_container_1_div_2_div_5_div_4_span_10_Template_span_mtConfirm_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const i_r11 = ɵngcc0.ɵɵnextContext().index; const ctx_r13 = ɵngcc0.ɵɵnextContext(4); return ctx_r13.deleteDoc(i_r11); });
    ɵngcc0.ɵɵelementEnd();
} }
function CommonDocumentsComponent_ng_container_1_div_2_div_5_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n                            ");
    ɵngcc0.ɵɵelementStart(2, "div", 13);
    ɵngcc0.ɵɵtext(3, "\n                                ");
    ɵngcc0.ɵɵelementStart(4, "span", 14);
    ɵngcc0.ɵɵlistener("click", function CommonDocumentsComponent_ng_container_1_div_2_div_5_div_4_Template_span_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r17); const i_r11 = ctx.index; const ctx_r16 = ɵngcc0.ɵɵnextContext(4); return ctx_r16.downloadDoc(i_r11); });
    ɵngcc0.ɵɵpipe(5, "fileicon");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n                                ");
    ɵngcc0.ɵɵelementStart(7, "span", 14);
    ɵngcc0.ɵɵlistener("click", function CommonDocumentsComponent_ng_container_1_div_2_div_5_div_4_Template_span_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r17); const i_r11 = ctx.index; const ctx_r18 = ɵngcc0.ɵɵnextContext(4); return ctx_r18.downloadDoc(i_r11); });
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(9, "\n                                ");
    ɵngcc0.ɵɵtemplate(10, CommonDocumentsComponent_ng_container_1_div_2_div_5_div_4_span_10_Template, 1, 0, "span", 15);
    ɵngcc0.ɵɵtext(11, "\n                            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(12, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const document_r10 = ctx.$implicit;
    const ctx_r9 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵclassMapInterpolate1("fa fa-fw ", ɵngcc0.ɵɵpipeBind1(5, 5, document_r10.Name), "");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", document_r10.Name, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.canEdit);
} }
function CommonDocumentsComponent_ng_container_1_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n                    ");
    ɵngcc0.ɵɵelementStart(2, "div", 11);
    ɵngcc0.ɵɵtext(3, "\n                        ");
    ɵngcc0.ɵɵtemplate(4, CommonDocumentsComponent_ng_container_1_div_2_div_5_div_4_Template, 13, 7, "div", 12);
    ɵngcc0.ɵɵtext(5, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n                ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.documentArray);
} }
function CommonDocumentsComponent_ng_container_1_div_2_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtext(1, "\n                    ");
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n                ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r5._max, " of ", ctx_r5._total, "");
} }
function CommonDocumentsComponent_ng_container_1_div_2_i_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i");
    ɵngcc0.ɵɵtext(1, "No Documents");
    ɵngcc0.ɵɵelementEnd();
} }
function CommonDocumentsComponent_ng_container_1_div_2_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵtext(1, "\n                    ");
    ɵngcc0.ɵɵelementStart(2, "button", 19);
    ɵngcc0.ɵɵlistener("click", function CommonDocumentsComponent_ng_container_1_div_2_div_11_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(3); return ctx_r19.isEditing = true; });
    ɵngcc0.ɵɵtext(3, "\n                        ");
    ɵngcc0.ɵɵelement(4, "span", 20);
    ɵngcc0.ɵɵtext(5, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n                ");
    ɵngcc0.ɵɵelementEnd();
} }
function CommonDocumentsComponent_ng_container_1_div_2_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵtext(1, "\n                    ");
    ɵngcc0.ɵɵelementStart(2, "a", 22);
    ɵngcc0.ɵɵlistener("click", function CommonDocumentsComponent_ng_container_1_div_2_div_13_Template_a_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(3); return ctx_r21.seeAll(); });
    ɵngcc0.ɵɵtext(3, "see all\n                        ");
    ɵngcc0.ɵɵelementStart(4, "span", 23);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(7, "\n                ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r8._total);
} }
function CommonDocumentsComponent_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelementStart(2, "h4");
    ɵngcc0.ɵɵtext(3, "Documents");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, "\n                ");
    ɵngcc0.ɵɵtemplate(5, CommonDocumentsComponent_ng_container_1_div_2_div_5_Template, 7, 1, "div", 7);
    ɵngcc0.ɵɵtext(6, "\n                ");
    ɵngcc0.ɵɵtemplate(7, CommonDocumentsComponent_ng_container_1_div_2_div_7_Template, 5, 2, "div", 8);
    ɵngcc0.ɵɵtext(8, "\n                ");
    ɵngcc0.ɵɵtemplate(9, CommonDocumentsComponent_ng_container_1_div_2_i_9_Template, 2, 0, "i", 7);
    ɵngcc0.ɵɵtext(10, "\n                ");
    ɵngcc0.ɵɵtemplate(11, CommonDocumentsComponent_ng_container_1_div_2_div_11_Template, 7, 0, "div", 9);
    ɵngcc0.ɵɵtext(12, "\n                ");
    ɵngcc0.ɵɵtemplate(13, CommonDocumentsComponent_ng_container_1_div_2_div_13_Template, 8, 1, "div", 10);
    ɵngcc0.ɵɵtext(14, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.documentArray.length);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showTotal);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.documentArray.length);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.canAdd);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showTotal);
} }
function CommonDocumentsComponent_ng_container_1_mt_document_6_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mt-document", 24);
    ɵngcc0.ɵɵlistener("onAfterAddingFile", function CommonDocumentsComponent_ng_container_1_mt_document_6_Template_mt_document_onAfterAddingFile_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(2); return ctx_r23.addDocument($event); })("onAddingFileFailed", function CommonDocumentsComponent_ng_container_1_mt_document_6_Template_mt_document_onAddingFileFailed_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r25 = ɵngcc0.ɵɵnextContext(2); return ctx_r25.onWhenAddingFileFailed($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("allowedMimeType", ctx_r2.documentUploadControlConfig.allowedMimeType)("maxFileSize", ctx_r2.documentUploadControlConfig.maxFileSize);
} }
function CommonDocumentsComponent_ng_container_1_mt_document_8_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mt-document", 25);
    ɵngcc0.ɵɵlistener("onAfterAddingFile", function CommonDocumentsComponent_ng_container_1_mt_document_8_Template_mt_document_onAfterAddingFile_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ctx_r26.addDocument($event); })("onAddingFileFailed", function CommonDocumentsComponent_ng_container_1_mt_document_8_Template_mt_document_onAddingFileFailed_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r28 = ɵngcc0.ɵɵnextContext(2); return ctx_r28.onWhenAddingFileFailed($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("allowedMimeType", ctx_r3.documentUploadControlConfig.allowedMimeType);
} }
function CommonDocumentsComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵtemplate(2, CommonDocumentsComponent_ng_container_1_div_2_Template, 15, 5, "div", 1);
    ɵngcc0.ɵɵtext(3, "\n            ");
    ɵngcc0.ɵɵelementStart(4, "div", 2);
    ɵngcc0.ɵɵtext(5, "\n                ");
    ɵngcc0.ɵɵtemplate(6, CommonDocumentsComponent_ng_container_1_mt_document_6_Template, 1, 2, "mt-document", 3);
    ɵngcc0.ɵɵtext(7, "\n                ");
    ɵngcc0.ɵɵtemplate(8, CommonDocumentsComponent_ng_container_1_mt_document_8_Template, 1, 1, "mt-document", 4);
    ɵngcc0.ɵɵtext(9, "\n\n                ");
    ɵngcc0.ɵɵelement(10, "br");
    ɵngcc0.ɵɵtext(11, "\n                ");
    ɵngcc0.ɵɵelementStart(12, "button", 5);
    ɵngcc0.ɵɵlistener("click", function CommonDocumentsComponent_ng_container_1_Template_button_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r29 = ɵngcc0.ɵɵnextContext(); return ctx_r29.cancel(); });
    ɵngcc0.ɵɵtext(13, "Cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(14, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(15, "\n        ");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.showUploadArea);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.showUploadArea);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.documentUploadControlConfig.maxFileSize);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.documentUploadControlConfig.maxFileSize);
} }
const _c0 = ["docComponent"];
function CommonDocumentsListComponent_div_1_div_30_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵlistener("click", function CommonDocumentsListComponent_div_1_div_30_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.isEditing = true; });
    ɵngcc0.ɵɵtext(1, "\n                ");
    ɵngcc0.ɵɵelementStart(2, "a", 17);
    ɵngcc0.ɵɵtext(3, "\n                    ");
    ɵngcc0.ɵɵelement(4, "span", 18);
    ɵngcc0.ɵɵtext(5, "\n                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, "\n            ");
    ɵngcc0.ɵɵelementEnd();
} }
const _c1 = function () { return ["../"]; };
function CommonDocumentsListComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "\n            ");
    ɵngcc0.ɵɵelementStart(2, "div");
    ɵngcc0.ɵɵtext(3, "\n                ");
    ɵngcc0.ɵɵelementStart(4, "div", 7);
    ɵngcc0.ɵɵtext(5, "\n                    ");
    ɵngcc0.ɵɵelement(6, "input", 8);
    ɵngcc0.ɵɵtext(7, "\n                    ");
    ɵngcc0.ɵɵelementStart(8, "span", 9);
    ɵngcc0.ɵɵtext(9, "\n                        ");
    ɵngcc0.ɵɵelementStart(10, "button", 10);
    ɵngcc0.ɵɵlistener("click", function CommonDocumentsListComponent_div_1_Template_button_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.clearSearch(); });
    ɵngcc0.ɵɵtext(11, "\n                            ");
    ɵngcc0.ɵɵelement(12, "i", 11);
    ɵngcc0.ɵɵtext(13, "\n                            ");
    ɵngcc0.ɵɵelement(14, "i", 12);
    ɵngcc0.ɵɵtext(15, "\n                            ");
    ɵngcc0.ɵɵelement(16, "i", 11);
    ɵngcc0.ɵɵtext(17, "\n                        ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(18, "\n                    ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(19, "\n                ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(20, "\n                ");
    ɵngcc0.ɵɵelement(21, "br");
    ɵngcc0.ɵɵtext(22, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(23, "\n            ");
    ɵngcc0.ɵɵelementStart(24, "entity-list", 13);
    ɵngcc0.ɵɵlistener("currentPageChange", function CommonDocumentsListComponent_div_1_Template_entity_list_currentPageChange_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.currentPage = $event; })("onPageChanged", function CommonDocumentsListComponent_div_1_Template_entity_list_onPageChanged_24_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.getDocuments(); })("onColumnSelected", function CommonDocumentsListComponent_div_1_Template_entity_list_onColumnSelected_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.downloadDocument($event); })("onColumnSorted", function CommonDocumentsListComponent_div_1_Template_entity_list_onColumnSorted_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.columnSorted($event); })("onItemDeleted", function CommonDocumentsListComponent_div_1_Template_entity_list_onItemDeleted_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.deleteDocument($event); });
    ɵngcc0.ɵɵtext(25, "\n            ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(26, "\n            ");
    ɵngcc0.ɵɵelementStart(27, "a", 14);
    ɵngcc0.ɵɵtext(28, "Back");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(29, "\n            ");
    ɵngcc0.ɵɵtemplate(30, CommonDocumentsListComponent_div_1_div_30_Template, 7, 0, "div", 15);
    ɵngcc0.ɵɵtext(31, "\n        ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("formControl", ctx_r0.searchControl);
    ɵngcc0.ɵɵadvance(18);
    ɵngcc0.ɵɵproperty("entities", ctx_r0.documentArray)("itemsPerPage", ctx_r0.itemsPerPage)("total", ctx_r0.total)("currentPage", ctx_r0.currentPage)("entityListConfig", ctx_r0.entityListConfig);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction0(8, _c1));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canEdit);
} }
function CommonDocumentsListComponent_mt_document_9_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mt-document", 19);
    ɵngcc0.ɵɵlistener("onAfterAddingFile", function CommonDocumentsListComponent_mt_document_9_Template_mt_document_onAfterAddingFile_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.addDocument($event); })("onAddingFileFailed", function CommonDocumentsListComponent_mt_document_9_Template_mt_document_onAddingFileFailed_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.onWhenAddingFileFailed($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("allowedMimeType", ctx_r1.documentUploadControlConfig.allowedMimeType)("maxFileSize", ctx_r1.documentUploadControlConfig.maxFileSize);
} }
function CommonDocumentsListComponent_mt_document_11_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mt-document", 20);
    ɵngcc0.ɵɵlistener("onAfterAddingFile", function CommonDocumentsListComponent_mt_document_11_Template_mt_document_onAfterAddingFile_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.addDocument($event); })("onAddingFileFailed", function CommonDocumentsListComponent_mt_document_11_Template_mt_document_onAddingFileFailed_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.onWhenAddingFileFailed($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("allowedMimeType", ctx_r2.documentUploadControlConfig.allowedMimeType);
} }
const defaultModuleConfig = {
    max: 3,
};
class EntityComponentsDocumentsModuleConfig {
    constructor(config) {
        Object.assign(this, defaultModuleConfig, config);
    }
}
EntityComponentsDocumentsModuleConfig.ɵfac = function EntityComponentsDocumentsModuleConfig_Factory(t) { return new (t || EntityComponentsDocumentsModuleConfig)(ɵngcc0.ɵɵinject(EntityComponentsDocumentsModuleConfigToken, 8)); };
EntityComponentsDocumentsModuleConfig.ɵprov = ɵɵdefineInjectable({ factory: function EntityComponentsDocumentsModuleConfig_Factory() { return new EntityComponentsDocumentsModuleConfig(ɵɵinject(EntityComponentsDocumentsModuleConfigToken, 8)); }, token: EntityComponentsDocumentsModuleConfig, providedIn: "root" });
EntityComponentsDocumentsModuleConfig.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [EntityComponentsDocumentsModuleConfigToken,] }, { type: Optional }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityComponentsDocumentsModuleConfig, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [EntityComponentsDocumentsModuleConfigToken]
            }, {
                type: Optional
            }] }]; }, null); })();

class CommonDocumentsComponent {
    constructor(injector) {
        this.injector = injector;
        this.errorHandler = new ComponentErrorHandler('CommonDocumentsComponent', '@mt-ng2/entity-components-documents');
        this._documentsPassedIn = false;
        this._documentArray = [];
        this.onAddDocument = new EventEmitter();
        this.onValidateFailed = new EventEmitter();
        this.onDeleteDocument = new EventEmitter();
        this.onDownloadDocument = new EventEmitter();
        this.route = injector.get(ActivatedRoute);
        this.router = injector.get(Router);
        this.notificationsService = injector.get(NotificationsService);
        this.claimsService = injector.get(ClaimsService);
        this.config = injector.get(EntityComponentsDocumentsModuleConfig);
        this._max = this.config.max;
    }
    set isEditing(value) {
        this.errorHandler.checkNull(value, 'isEditing');
        this._isEditing = value;
    }
    set total(value) {
        this.errorHandler.checkNull(value, 'total');
        this._total = value;
    }
    set max(value) {
        this.errorHandler.checkNull(value, 'max');
        this._max = value;
    }
    get canEdit() {
        return this._canEdit;
    }
    set canEdit(value) {
        this.errorHandler.checkNull(value, 'canEdit');
        this._canEdit = value;
    }
    get canAdd() {
        return this._canAdd;
    }
    set canAdd(value) {
        this.errorHandler.checkNull(value, 'canAdd');
        this._canAdd = value;
    }
    set seeAllUrl(value) {
        this._seeAllUrl = value;
    }
    set documentArray(value) {
        this.errorHandler.checkNull(value, 'documentArray');
        this._documentArray = value;
        this._documentsPassedIn = true;
    }
    get documentArray() {
        return this._documentArray;
    }
    get service() {
        if (!this._documentsPassedIn && this._service && this.parentId && this.parentId > 0) {
            return this._service;
        }
        return null;
    }
    set service(value) {
        this._service = value;
    }
    get documentUploadControlConfig() {
        return this._documentUploadControlConfig;
    }
    set documentUploadControlConfig(value) {
        this._documentUploadControlConfig = value;
    }
    set allowedMimeType(value) {
        this._allowedMimeType = value;
    }
    ngOnInit() {
        this.setVariables();
        this.isEditing = false;
        this.getDocuments();
    }
    /**
     * Assigns local variables to defaults or config properties.
     */
    setVariables() {
        const config = this.route.parent.snapshot.data;
        if (config && config.entityIdParam) {
            this.parentId = +this.route.parent.snapshot.paramMap.get(config.entityIdParam);
        }
        const service = this.service || (config && config.service) || null;
        if (service) {
            if (typeof service === 'function') {
                this.service = this.injector.get(service);
            }
        }
        if (this._canEdit === undefined) {
            this._canEdit = config && config.claimType ? this.claimsService.hasClaim(config.claimType, [ClaimValues.FullAccess]) : false;
        }
        if (this._canAdd === undefined) {
            this._canAdd = this._canEdit;
        }
        if (this._seeAllUrl === undefined) {
            this._seeAllUrl = (config && config.documentsPath) || 'documents';
        }
        if (this._documentUploadControlConfig === undefined) {
            if (this._service && this._service.documentUploadControlConfig) {
                this._documentUploadControlConfig = this._service.documentUploadControlConfig;
            }
            else {
                this._documentUploadControlConfig = {};
            }
        }
        this._documentUploadControlConfig.allowedMimeType = this._allowedMimeType ||
            this.documentUploadControlConfig.allowedMimeType || ['image/png', 'image/jpg', 'image/jpeg', 'image/gif', 'application/zip'];
    }
    get showUploadArea() {
        return this._isEditing && this._canEdit;
    }
    get showEditButton() {
        return this._canEdit;
    }
    get showTotal() {
        return this._total && this._total > this._max;
    }
    seeAll() {
        this.router.navigate([`${this._seeAllUrl}`], {
            relativeTo: this.route,
        });
    }
    getDocuments() {
        if (this.service) {
            const searchparamProperties = {
                order: 'DateUpload',
                orderDirection: SortDirection.Desc,
                query: '',
                take: this._max,
            };
            const searchparams = new SearchParams(searchparamProperties);
            this.service.getDocuments(this.parentId, searchparams).subscribe((response) => {
                this._documentArray = response.body;
                this._total = +response.headers.get('X-List-Count');
            });
        }
    }
    onWhenAddingFileFailed(message) {
        if (!this._documentsPassedIn) {
            this.notificationsService.error(message);
        }
        this.onValidateFailed.emit(message);
    }
    addDocument(file) {
        this.isEditing = false;
        if (this._documentsPassedIn) {
            this.onAddDocument.emit(file);
        }
        else {
            this.saveDocument(file);
        }
    }
    saveDocument(file) {
        if (file) {
            this._service.saveDocument(this.parentId, file._file).subscribe((x) => {
                if (this._documentArray.length >= 3) {
                    this._documentArray.splice(0, 1);
                }
                this._documentArray.push(x);
                this._total += 1;
                this.onAddDocument.emit(file);
            });
        }
    }
    cancel() {
        this.isEditing = false;
    }
    deleteDoc(index) {
        if (!this._documentsPassedIn) {
            this._service.deleteDocument(this.parentId, this._documentArray[index].Id).subscribe(() => {
                if (this._total > 3) {
                    this.getDocuments();
                }
                else {
                    this._documentArray.splice(index, 1);
                    this._total -= 1;
                }
            });
        }
        this.onDeleteDocument.emit(this._documentArray[index]);
    }
    downloadDoc(index) {
        if (!this._documentsPassedIn) {
            this._service.getDocument(this.parentId, this._documentArray[index].Id).subscribe((x) => {
                const thefile = new Blob([x], {
                    type: 'application/octet-stream',
                });
                saveAs(thefile, this._documentArray[index].Name);
            });
        }
        else {
            this.onDownloadDocument.emit(this._documentArray[index]);
        }
    }
}
CommonDocumentsComponent.ɵfac = function CommonDocumentsComponent_Factory(t) { return new (t || CommonDocumentsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
CommonDocumentsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CommonDocumentsComponent, selectors: [["app-common-documents"]], inputs: { isEditing: "isEditing", total: "total", max: "max", canEdit: "canEdit", canAdd: "canAdd", seeAllUrl: "seeAllUrl", documentArray: "documentArray", service: "service", documentUploadControlConfig: "documentUploadControlConfig", allowedMimeType: "allowedMimeType" }, outputs: { onAddDocument: "onAddDocument", onValidateFailed: "onValidateFailed", onDeleteDocument: "onDeleteDocument", onDownloadDocument: "onDownloadDocument" }, decls: 3, vars: 1, consts: [[4, "componentErrorHandler"], ["class", "miles-card padded", 4, "ngIf"], [1, "miles-form", "padded", 3, "hidden"], [3, "allowedMimeType", "maxFileSize", "onAfterAddingFile", "onAddingFileFailed", 4, "ngIf"], [3, "allowedMimeType", "onAfterAddingFile", "onAddingFileFailed", 4, "ngIf"], ["type", "button", 1, "btn", "btn-flat", "btn-default", 3, "click"], [1, "miles-card", "padded"], [4, "ngIf"], ["class", "pull-right max-of-total", 4, "ngIf"], ["class", "fab-wrap", 4, "ngIf"], ["class", "show-on-hover", 4, "ngIf"], [1, "row"], [4, "ngFor", "ngForOf"], [1, "col-xs-4", "miles-inline-list"], [3, "click"], ["class", "fa fa-fw fa-trash text-danger delete", 3, "mtConfirm", 4, "ngIf"], [1, "fa", "fa-fw", "fa-trash", "text-danger", "delete", 3, "mtConfirm"], [1, "pull-right", "max-of-total"], [1, "fab-wrap"], ["type", "button", 1, "btn", "btn-primary", "btn-fab-md", "btn-fab-center", 3, "click"], [1, "fa", "fa-plus"], [1, "show-on-hover"], [1, "btn", "btn-primary", "btn-flat", "see-all", 3, "click"], [1, "badge"], [3, "allowedMimeType", "maxFileSize", "onAfterAddingFile", "onAddingFileFailed"], [3, "allowedMimeType", "onAfterAddingFile", "onAddingFileFailed"]], template: function CommonDocumentsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵtemplate(1, CommonDocumentsComponent_ng_container_1_Template, 16, 4, "ng-container", 0);
        ɵngcc0.ɵɵtext(2, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("componentErrorHandler", ctx.errorHandler);
    } }, directives: function () { return [ɵngcc1.ComponentErrorHandlerDirective, ɵngcc2.NgIf, ɵngcc2.NgForOf, ɵngcc3.MtConfirmDirective, ɵngcc4.MtDocumentComponent]; }, pipes: function () { return [FileIconPipe]; }, encapsulation: 2 });
CommonDocumentsComponent.ctorParameters = () => [
    { type: Injector }
];
CommonDocumentsComponent.propDecorators = {
    isEditing: [{ type: Input, args: ['isEditing',] }],
    total: [{ type: Input, args: ['total',] }],
    max: [{ type: Input, args: ['max',] }],
    canEdit: [{ type: Input, args: ['canEdit',] }],
    canAdd: [{ type: Input, args: ['canAdd',] }],
    seeAllUrl: [{ type: Input, args: ['seeAllUrl',] }],
    documentArray: [{ type: Input, args: ['documentArray',] }],
    service: [{ type: Input, args: ['service',] }],
    documentUploadControlConfig: [{ type: Input, args: ['documentUploadControlConfig',] }],
    allowedMimeType: [{ type: Input, args: ['allowedMimeType',] }],
    onAddDocument: [{ type: Output, args: ['onAddDocument',] }],
    onValidateFailed: [{ type: Output, args: ['onValidateFailed',] }],
    onDeleteDocument: [{ type: Output, args: ['onDeleteDocument',] }],
    onDownloadDocument: [{ type: Output, args: ['onDownloadDocument',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CommonDocumentsComponent, [{
        type: Component,
        args: [{
                selector: 'app-common-documents',
                template: `
        <ng-container *componentErrorHandler="errorHandler">
            <div class="miles-card padded" *ngIf="!showUploadArea">
                <h4>Documents</h4>
                <div *ngIf="documentArray.length">
                    <div class="row">
                        <div *ngFor="let document of documentArray; let i = index">
                            <div class="col-xs-4 miles-inline-list">
                                <span class="fa fa-fw {{ document.Name | fileicon }}" (click)="downloadDoc(i)"></span>
                                <span (click)="downloadDoc(i)"> {{ document.Name }}</span>
                                <span *ngIf="canEdit" class="fa fa-fw fa-trash text-danger delete" (mtConfirm)="deleteDoc(i)"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="showTotal" class="pull-right max-of-total">
                    <span>{{ _max }} of {{ _total }}</span>
                </div>
                <i *ngIf="!documentArray.length">No Documents</i>
                <div *ngIf="canAdd" class="fab-wrap">
                    <button type="button" class="btn btn-primary btn-fab-md btn-fab-center" (click)="isEditing = true">
                        <span class="fa fa-plus"></span>
                    </button>
                </div>
                <div *ngIf="showTotal" class="show-on-hover">
                    <a (click)="seeAll()" class="btn btn-primary btn-flat see-all"
                        >see all
                        <span class="badge">{{ _total }}</span>
                    </a>
                </div>
            </div>
            <div [hidden]="!showUploadArea" class="miles-form padded">
                <mt-document
                    *ngIf="documentUploadControlConfig.maxFileSize"
                    [allowedMimeType]="documentUploadControlConfig.allowedMimeType"
                    [maxFileSize]="documentUploadControlConfig.maxFileSize"
                    (onAfterAddingFile)="addDocument($event)"
                    (onAddingFileFailed)="onWhenAddingFileFailed($event)"
                ></mt-document>
                <mt-document
                    *ngIf="!documentUploadControlConfig.maxFileSize"
                    [allowedMimeType]="documentUploadControlConfig.allowedMimeType"
                    (onAfterAddingFile)="addDocument($event)"
                    (onAddingFileFailed)="onWhenAddingFileFailed($event)"
                ></mt-document>

                <br />
                <button type="button" class="btn btn-flat btn-default" (click)="cancel()">Cancel</button>
            </div>
        </ng-container>
    `
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, { onAddDocument: [{
            type: Output,
            args: ['onAddDocument']
        }], onValidateFailed: [{
            type: Output,
            args: ['onValidateFailed']
        }], onDeleteDocument: [{
            type: Output,
            args: ['onDeleteDocument']
        }], onDownloadDocument: [{
            type: Output,
            args: ['onDownloadDocument']
        }], isEditing: [{
            type: Input,
            args: ['isEditing']
        }], total: [{
            type: Input,
            args: ['total']
        }], max: [{
            type: Input,
            args: ['max']
        }], canEdit: [{
            type: Input,
            args: ['canEdit']
        }], canAdd: [{
            type: Input,
            args: ['canAdd']
        }], seeAllUrl: [{
            type: Input,
            args: ['seeAllUrl']
        }], documentArray: [{
            type: Input,
            args: ['documentArray']
        }], service: [{
            type: Input,
            args: ['service']
        }], documentUploadControlConfig: [{
            type: Input,
            args: ['documentUploadControlConfig']
        }], allowedMimeType: [{
            type: Input,
            args: ['allowedMimeType']
        }] }); })();

class DocumentsEntityListConfig extends EntityListConfig {
    constructor() {
        super({
            columns: [
                new EntityListColumn({
                    accessorFunction: function (document) {
                        return `<span class="fa fa-fw ${getFontAwesomeFileImage(document.Name)}"></span><span>${document.Name}</span>`;
                    },
                    bindToInnerHtml: true,
                    fireOnColumnSelected: true,
                    name: 'File',
                    sort: {
                        sortProperty: 'Name',
                    },
                }),
                new EntityListColumn({
                    accessors: ['DateUpload'],
                    name: 'Date Uploaded',
                    pipes: [`date:'medium'`],
                    sort: {
                        defaultDirection: SortDirection.Desc,
                        isDefaultForSort: true,
                    },
                }),
                new EntityListColumn({
                    accessors: ['User', 'AuthUser', 'Username'],
                    name: 'Uploaded By',
                }),
            ],
            delete: {
                confirm: true,
                width: 50,
            },
        });
    }
}

class CommonDocumentsListComponent {
    constructor(injector) {
        this.injector = injector;
        this._documentArray = [];
        this.searchControl = new FormControl();
        this.itemsPerPage = 12;
        this.currentPage = 1;
        this.entityListConfig = new DocumentsEntityListConfig();
        this.order = this.entityListConfig.getDefaultSortProperty();
        this.orderDirection = this.entityListConfig.getDefaultSortDirection();
        this.route = injector.get(ActivatedRoute);
        this.notificationsService = injector.get(NotificationsService);
        this.claimsService = injector.get(ClaimsService);
    }
    get documentArray() {
        return this._documentArray;
    }
    set isEditing(value) {
        this._isEditing = value;
    }
    set canEdit(value) {
        this._canEdit = value;
    }
    get canEdit() {
        return this._canEdit;
    }
    get service() {
        if (this._service && this.id && this.id > 0) {
            return this._service;
        }
        return null;
    }
    set service(value) {
        this._service = value;
    }
    ngOnInit() {
        this.searchControl.valueChanges.pipe(debounceTime(300)).subscribe((value) => this.getDocuments());
        this.setVariables();
        this.getDocuments();
    }
    setVariables() {
        const config = this.route.parent.snapshot.data;
        this.id = +this.route.parent.snapshot.paramMap.get(config.entityIdParam);
        this.canEdit = this.claimsService.hasClaim(config.claimType, [ClaimValues.FullAccess]);
        const service = this.getServiceFromConfig(config);
        this.service = this.injector.get(service);
        this.documentUploadControlConfig = this.service.documentUploadControlConfig || {};
        this.documentUploadControlConfig.allowedMimeType = this.documentUploadControlConfig.allowedMimeType || [
            'image/png',
            'image/jpg',
            'image/jpeg',
            'image/gif',
            'application/zip',
        ];
    }
    getServiceFromConfig(config) {
        let childRoute = this.route.snapshot || null;
        while (childRoute && childRoute.firstChild) {
            childRoute = childRoute.firstChild;
        }
        const childConfig = (childRoute && childRoute.data) || null;
        return childConfig && childConfig.service ? childConfig.service : config && config.service;
    }
    getDocuments() {
        const search = this.searchControl.value;
        const searchEntity = {
            order: this.order,
            orderDirection: this.orderDirection,
            query: search && search.length > 0 ? search : '',
            skip: (this.currentPage - 1) * this.itemsPerPage,
            take: this.itemsPerPage,
        };
        const searchparams = new SearchParams(searchEntity);
        this.service.getDocuments(this.id, searchparams).subscribe((response) => {
            this._documentArray = response.body;
            this.total = +response.headers.get('X-List-Count');
        });
    }
    columnSorted(event) {
        this.order = event.column.sort.sortProperty;
        this.orderDirection = event.column.sort.direction === SortDirection.Desc ? 'desc' : 'asc';
        this.getDocuments();
    }
    clearSearch() {
        this.searchControl.setValue('');
    }
    get showUploadArea() {
        return this._isEditing && this._canEdit;
    }
    onWhenAddingFileFailed(message) {
        this.notificationsService.error(message);
    }
    addDocument(file) {
        this.isEditing = false;
        this.saveDocument(file);
    }
    saveDocument(file) {
        if (file) {
            this._service.saveDocument(this.id, file._file).subscribe((x) => {
                this.getDocuments();
            });
        }
    }
    cancel() {
        this.isEditing = false;
    }
    deleteDocument(event) {
        this._service.deleteDocument(this.id, event.entity.Id).subscribe((x) => {
            this.getDocuments();
        });
    }
    downloadDocument(event) {
        this._service.getDocument(this.id, event.entity.Id).subscribe((x) => {
            const thefile = new Blob([x], { type: 'application/octet-stream' });
            saveAs(thefile, event.entity.Name);
        });
    }
}
CommonDocumentsListComponent.ɵfac = function CommonDocumentsListComponent_Factory(t) { return new (t || CommonDocumentsListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
CommonDocumentsListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CommonDocumentsListComponent, selectors: [["common-documents-list"]], viewQuery: function CommonDocumentsListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.docComponent = _t.first);
    } }, decls: 21, vars: 4, consts: [[4, "ngIf"], [1, "row", 3, "hidden"], [1, "col-md-6"], [1, "miles-form", "padded"], [3, "allowedMimeType", "maxFileSize", "onAfterAddingFile", "onAddingFileFailed", 4, "ngIf"], [3, "allowedMimeType", "onAfterAddingFile", "onAddingFileFailed", 4, "ngIf"], ["type", "button", 1, "btn", "btn-flat", "btn-default", 3, "click"], [1, "input-group"], ["type", "text", "placeholder", "Search", 1, "form-control", 3, "formControl"], [1, "input-group-btn"], ["type", "button", 1, "btn", "btn-default", "btn-nohover", "btn-flat", 3, "click"], [1, "fa"], ["aria-hidden", "true", 1, "fa", "fa-remove"], [3, "entities", "itemsPerPage", "total", "currentPage", "entityListConfig", "currentPageChange", "onPageChanged", "onColumnSelected", "onColumnSorted", "onItemDeleted"], [1, "btn", "btn-default", 3, "routerLink"], ["class", "fab-wrap-b-r", 3, "click", 4, "ngIf"], [1, "fab-wrap-b-r", 3, "click"], [1, "btn", "btn-primary", "btn-fab-lg"], [1, "fa", "fa-plus"], [3, "allowedMimeType", "maxFileSize", "onAfterAddingFile", "onAddingFileFailed"], [3, "allowedMimeType", "onAfterAddingFile", "onAddingFileFailed"]], template: function CommonDocumentsListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "\n        ");
        ɵngcc0.ɵɵtemplate(1, CommonDocumentsListComponent_div_1_Template, 32, 9, "div", 0);
        ɵngcc0.ɵɵtext(2, "\n        ");
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵtext(4, "\n            ");
        ɵngcc0.ɵɵelementStart(5, "div", 2);
        ɵngcc0.ɵɵtext(6, "\n                ");
        ɵngcc0.ɵɵelementStart(7, "div", 3);
        ɵngcc0.ɵɵtext(8, "\n                    ");
        ɵngcc0.ɵɵtemplate(9, CommonDocumentsListComponent_mt_document_9_Template, 1, 2, "mt-document", 4);
        ɵngcc0.ɵɵtext(10, "\n                    ");
        ɵngcc0.ɵɵtemplate(11, CommonDocumentsListComponent_mt_document_11_Template, 1, 1, "mt-document", 5);
        ɵngcc0.ɵɵtext(12, "\n                    ");
        ɵngcc0.ɵɵelement(13, "br");
        ɵngcc0.ɵɵtext(14, "\n                    ");
        ɵngcc0.ɵɵelementStart(15, "button", 6);
        ɵngcc0.ɵɵlistener("click", function CommonDocumentsListComponent_Template_button_click_15_listener() { return ctx.cancel(); });
        ɵngcc0.ɵɵtext(16, "Cancel");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(17, "\n                ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(18, "\n            ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(19, "\n        ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(20, "\n    ");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.showUploadArea);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !ctx.showUploadArea);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", ctx.documentUploadControlConfig.maxFileSize);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.documentUploadControlConfig.maxFileSize);
    } }, directives: [ɵngcc2.NgIf, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.FormControlDirective, ɵngcc6.EntityListComponent, ɵngcc7.RouterLinkWithHref, ɵngcc4.MtDocumentComponent], encapsulation: 2 });
CommonDocumentsListComponent.ctorParameters = () => [
    { type: Injector }
];
CommonDocumentsListComponent.propDecorators = {
    docComponent: [{ type: ViewChild, args: ['docComponent',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CommonDocumentsListComponent, [{
        type: Component,
        args: [{
                selector: 'common-documents-list',
                template: `
        <div *ngIf="!showUploadArea">
            <div>
                <div class="input-group">
                    <input type="text" [formControl]="searchControl" class="form-control" placeholder="Search" />
                    <span class="input-group-btn">
                        <button type="button" (click)="clearSearch()" class="btn btn-default btn-nohover btn-flat">
                            <i class="fa"></i>
                            <i class="fa fa-remove" aria-hidden="true"></i>
                            <i class="fa"></i>
                        </button>
                    </span>
                </div>
                <br />
            </div>
            <entity-list
                [entities]="documentArray"
                [itemsPerPage]="itemsPerPage"
                [total]="total"
                [(currentPage)]="currentPage"
                (onPageChanged)="getDocuments()"
                (onColumnSelected)="downloadDocument($event)"
                (onColumnSorted)="columnSorted($event)"
                (onItemDeleted)="deleteDocument($event)"
                [entityListConfig]="entityListConfig"
            >
            </entity-list>
            <a [routerLink]="['../']" class="btn btn-default">Back</a>
            <div *ngIf="canEdit" class="fab-wrap-b-r" (click)="isEditing = true">
                <a class="btn btn-primary btn-fab-lg">
                    <span class="fa fa-plus"></span>
                </a>
            </div>
        </div>
        <div [hidden]="!showUploadArea" class="row">
            <div class="col-md-6">
                <div class="miles-form padded">
                    <mt-document
                        *ngIf="documentUploadControlConfig.maxFileSize"
                        [allowedMimeType]="documentUploadControlConfig.allowedMimeType"
                        [maxFileSize]="documentUploadControlConfig.maxFileSize"
                        (onAfterAddingFile)="addDocument($event)"
                        (onAddingFileFailed)="onWhenAddingFileFailed($event)"
                    ></mt-document>
                    <mt-document
                        *ngIf="!documentUploadControlConfig.maxFileSize"
                        [allowedMimeType]="documentUploadControlConfig.allowedMimeType"
                        (onAfterAddingFile)="addDocument($event)"
                        (onAddingFileFailed)="onWhenAddingFileFailed($event)"
                    ></mt-document>
                    <br />
                    <button type="button" class="btn btn-flat btn-default" (click)="cancel()">Cancel</button>
                </div>
            </div>
        </div>
    `
            }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, { docComponent: [{
            type: ViewChild,
            args: ['docComponent']
        }] }); })();

class FileIconPipe {
    constructor() { }
    transform(filename) {
        return getFontAwesomeFileImage(filename);
    }
}
FileIconPipe.ɵfac = function FileIconPipe_Factory(t) { return new (t || FileIconPipe)(); };
FileIconPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "fileicon", type: FileIconPipe, pure: true });
FileIconPipe.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FileIconPipe, [{
        type: Pipe,
        args: [{
                name: 'fileicon'
            }]
    }], function () { return []; }, null); })();

class EntityComponentsDocumentsModule {
}
EntityComponentsDocumentsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EntityComponentsDocumentsModule });
EntityComponentsDocumentsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EntityComponentsDocumentsModule_Factory(t) { return new (t || EntityComponentsDocumentsModule)(); }, imports: [[
            CommonModule,
            NgbModule,
            RouterModule,
            DynamicFormModule,
            MtDocumentControlModule,
            MtAlertsModule,
            EntityListModule,
            ComponentErrorHandlerModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EntityComponentsDocumentsModule, { declarations: function () { return [CommonDocumentsComponent, CommonDocumentsListComponent, FileIconPipe]; }, imports: function () { return [CommonModule,
        NgbModule,
        RouterModule,
        DynamicFormModule,
        MtDocumentControlModule,
        MtAlertsModule,
        EntityListModule,
        ComponentErrorHandlerModule]; }, exports: function () { return [CommonDocumentsComponent, CommonDocumentsListComponent, FileIconPipe]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EntityComponentsDocumentsModule, [{
        type: NgModule,
        args: [{
                declarations: [CommonDocumentsComponent, CommonDocumentsListComponent, FileIconPipe],
                exports: [CommonDocumentsComponent, CommonDocumentsListComponent, FileIconPipe],
                imports: [
                    CommonModule,
                    NgbModule,
                    RouterModule,
                    DynamicFormModule,
                    MtDocumentControlModule,
                    MtAlertsModule,
                    EntityListModule,
                    ComponentErrorHandlerModule,
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { CommonDocumentsComponent, CommonDocumentsListComponent, EntityComponentsDocumentsModule, FileIconPipe };

//# sourceMappingURL=mt-ng2-entity-components-documents.js.map